import React from 'react';
import { DatePicker } from '../../DatePicker';
import { Button } from '../../Button';
import { ComponentWrapper } from '../../ComponentWrapper';
import { Dropdown } from '../../Dropdown';
import { appBarCss } from '../utils';
export const AppBarItem = ({ data, }) => {
    const { appBarSpace, appBarButton } = appBarCss({
        customClassName: data.className,
        overrideCss: data.overrideClassName,
    });
    if (data.type === 'datepicker') {
        return (React.createElement("div", { className: appBarSpace },
            React.createElement(DatePicker, Object.assign({}, data))));
    }
    if (data.type === 'dropdown') {
        return (React.createElement("div", { className: appBarSpace },
            React.createElement(Dropdown, Object.assign({}, data))));
    }
    if (data.type === 'button') {
        return (React.createElement("div", { className: appBarSpace },
            React.createElement("div", { className: appBarButton },
                React.createElement(Button, Object.assign({}, data)))));
    }
    if (data.type === 'customOption') {
        return (React.createElement("div", { className: appBarSpace },
            React.createElement(ComponentWrapper, { component: data.component })));
    }
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=AppBarItem.js.map